import { z } from "zod";

const RemoveItemFromWatchSchema = z
  .object({
    id: z.string().uuid({ message: "Id is required." }),
  })
  .strict();

export default RemoveItemFromWatchSchema;
